import React, { useState, useEffect } from "react";
import InputField from "../../../components/InputField";
import TextAreaField from "../../../components/TextAreaField";
import { Link } from "react-router-dom";
import ErrorAlert from "../../../components/ErrorAlert";
import AlertComponent from "../../../components/AlertComponent";
import GetItemById from "../api/GetItemById";
import CreateNewItem from "../api/CreateNewItem";
import UploadImage from "../api/UploadImage";

function CreateForm({ levelNumber = 1, itemId = null }) {
  // define alert and FormData Using In Create New Item
  const [alert, setAlert] = useState("null");
  const [formData, setFormData] = useState({
    item: null,
    name: "",
    usdPrice: levelNumber === 1 || levelNumber === 2 ? "-9" : "0",
    iraqiPrice: levelNumber === 1 || levelNumber === 2 ? "-9" : "0",
    moreSale: false,
    description: "",
    image: null,
  });

  // Getting Item Data for adding in 2, 3 th level
  useEffect(() => {
    if (itemId) {
      const getItemData = async () => {
        const item = await GetItemById(itemId);
        setFormData((prevState) => ({
          ...prevState,
          item: item,
        }));
      };

      getItemData();
    }
  }, [itemId]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else if (type === "file") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: name === "usdPrice" || name === "iraqiPrice" ? value.toString() : value,
      }));
    }
  };

  // Handle Adding Item Submit
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let newItem = {
      parentId: itemId ? itemId : null,
      name: formData.name,
      ename: formData.name,
      country: null,
      image: null,
      status: 1,
      usdprice: formData.usdprice,
      iraqiPrice: formData.iraqiPrice,
      description: formData.description,
      moresales: formData.moreSale ? 1 : 2,
    };
    let dataId = await CreateNewItem(newItem);
    if (dataId) {
      let dataImage = await UploadImage({
        dataId: dataId.toString(),
        imageFile: formData.image,
      });
      if (dataImage) {
        setAlert("create");
      } else {
        setAlert("error");
      }
    } else {
      setAlert("error");
    }
    // to remove alert after Show
    setTimeout(() => {
      setAlert("null");
    }, 5000);
  };

  return (
    <>
      {" "}
      <section className="body-font relative text-gray-600">
        <div className="container mx-auto flex px-5 py-4">
          <div className="flex w-full flex-col items-end rounded-lg bg-white p-8">
            {alert === "error" ? (
              <ErrorAlert
                title={"فشل في عملية إضافة منتج جديد"}
                content={"حدث خطا في عملية إضافة منتج جديد"}
              />
            ) : alert === "create" ? (
              <AlertComponent
                title={" تمت إضافة منتج جديد بنجاح"}
                content={`تمت إضافة منتج جديد بإسم  ${formData.name}  بنجاح`}
              />
            ) : (
              ""
            )}

            <div className="w-full flex flex-col md:flex-row-reverse justify-between items-center border-b mb-8 pb-4">
              <h2 className="title-font  text-lg font-medium text-gray-900">
                إضافة منتج جديد
                <span>{formData.item !== null ? ` ضمن فئة ${formData.item.name} ` : ""}</span>
              </h2>
              <Link
                to={`${
                  itemId !== null
                    ? `${process.env.PUBLIC_URL}/item/${itemId}`
                    : `${process.env.PUBLIC_URL}/items`
                }`}
                className="text-lg text-blue-500 font-bold underline"
              >
                {itemId !== null ? "الرجوع لصفحة المنتح الرئيسية" : "الرجوع لصفحة المنتجات الرئيسة"}
              </Link>
            </div>

            <form
              method="POST"
              className="w-full"
              onSubmit={handleFormSubmit}
              encType="multipart/form-data"
            >
              <InputField
                label={"الاسم"}
                name="name"
                value={formData.name}
                required={true}
                onChange={handleChange}
              />
              <InputField
                label={"السعر العراقي"}
                name="usdPrice"
                type="number"
                value={formData.usdPrice}
                onChange={handleChange}
                min={"0"}
                disabled={levelNumber === 1 || levelNumber === 2 ? true : false}
              />
              <InputField
                label={"السعر بالدولار"}
                name="iraqiPrice"
                type="number"
                value={formData.iraqiPrice}
                onChange={handleChange}
                min={"0"}
                disabled={levelNumber === 1 || levelNumber === 2 ? true : false}
              />
              <InputField
                label={" جعل المنتج الإكثر طلباً"}
                name="moreSale"
                type="checkbox"
                value={formData.moreSale}
                onChange={handleChange}
              />

              <InputField
                label={"صورة المنتج"}
                name="image"
                type="file"
                accept="image/*"
                required={true}
                onChange={handleChange}
              />
              <TextAreaField
                label={"وصف المنتج"}
                value={formData.description}
                onChange={handleChange}
              />

              <button
                type="submit"
                className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
              >
                إضاقة منتج
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default CreateForm;
